import React from 'react';
import { Result } from 'antd';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { hasPermission } from '../../utils/permission';
import { getSidebarItems, getSideBarMenuRoutes } from '../../components/layout/SideBarMenuRoutes';

const PageNotFound = () => {
    const { user } = useSelector((state) => state.session);
    const navigate = useNavigate();

    const navigateToDashboard = () => {
        const sideMarItems = getSidebarItems(
            user?.authorities,
            { isClientHqEnabled: user?.isClientHqEnabled },
            getSideBarMenuRoutes({ isClientHqEnabled: user?.isClientHqEnabled }),
        );

        navigate(sideMarItems[0]?.href || '/account');
    };

    return (
        <Result
            status="404"
            title="404"
            subTitle="Sorry, the page you visited does not exist."
            extra={
                <Button type="primary" variant="contained" onClick={navigateToDashboard}>
                    Go to home
                </Button>
            }
        />
    );
};

export default PageNotFound;
